import { Component, OnInit } from "@angular/core";
import { AdminService } from "../service/admin.service";
import { Router } from "@angular/router";

@Component({
    selector: 'app-header',
    template: require('./header.component.html'),
    styles: [require('./header.component.css')]
})
export class HeaderComponent implements OnInit {

    constructor(private router: Router, private adminService: AdminService) {
        //console.log(`HeaderComponent`);
    }

    ngOnInit(): void {
    }

    isLoggedIn(): boolean {
        //return this.adminService.isLoggedIn();
        return false;
    }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./~/angular2-template-loader!./src/app/header/header.component.ts